import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c1fj2fenif: FaireBrandEntity = {
  token: "b_c1fj2fenif",
  type: "brand",
  name: "Picki Nicki",
  avatarUrl:
    "https://cdn.faire.com/fastly/ae0db6e738a7d953a4c15f1354a7170c4d2f516bb6c2848921e2815c6e3f9009.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7cc3554a18bbbce510091443aa7a835dd3c86a6f04f072c5b33c2600d215b40b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ae0db6e738a7d953a4c15f1354a7170c4d2f516bb6c2848921e2815c6e3f9009.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7cc3554a18bbbce510091443aa7a835dd3c86a6f04f072c5b33c2600d215b40b.png",
  location: "Menifee, CA, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 1759,
  isTopShop: true,
  isInsider: true,
  description:
    "Picki Nicki is a family-owned California brand creating handcrafted botanical gifts that inspire moments of peace, intention, and everyday beauty. Founded in sunny Southern California, our mission is simple: help people slow down, practice self-care, and create meaningful spaces through thoughtfully designed products made with natural botanicals and genuine crystals.\nFrom our bestselling White Sage and Palo Santo collections to our intention-inspired gemstone bracelets, dried floral bouquets, crystal candles, and wellness gifts, every piece is handcrafted with care to bring a sense of calm, joy, and connection.\nRooted in Sustainability\nWe're passionate about protecting the future of White Sage. That's why we partner with local Southern California farms that cultivate White Sage responsibly rather than harvesting it from the wild. By supporting sustainable farming practices, we're helping preserve this sacred plant while providing our retailers with high-quality, ethically sourced products they can feel good about offering their customers.\nOur collections are designed to help independent retailers stand out with products that are:\nHandcrafted in California\nSustainably sourced whenever possible\nBeautifully merchandised and gift-ready\nPerfect for boutiques, gift shops, florists, spas, yoga studios, garden centers, and wellness stores\nConsistent bestsellers with year-round appeal\nWe take pride in offering exceptional customer service.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:09.335Z",
    importedBy: "entity-db-cli",
  },
};
